export default __webpack_public_path__ + "static/media/icon-like-poppy.eb385291.png";